// extracted by mini-css-extract-plugin
module.exports = {"circle":"MessageCenterContainer-module_circle_1P5NOoU7WH","iconPadding":"MessageCenterContainer-module_iconPadding_5YlsjSH6Yz"};